import { Metamodel } from 'app/model/base/model';
import { FormatTypeCopySource } from './format-type.copysource';
import { JsonDataset } from 'shell-models-lib';

@Metamodel.model({
    name: 'JsonSource',
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(JsonDataset)]}
})
export class JsonCopySource extends FormatTypeCopySource {
}
